import {
    CounterpartiesPageResponse,
    CounterpartiesRequestParams,
} from '@entities/counterparties/types';
import api from '@shared/api';

const PATH = 'invoice-api/api/v2/invoices';
export const fetch = async (payload: CounterpartiesRequestParams) =>
    (await api.post<CounterpartiesPageResponse>(`${PATH}/partners`, payload)).data;
